import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// ui
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import './Style.css';

export default function ModalComp(props) {
  const [scroll] = React.useState('paper');
  const {
    open,
    size,
    modalHeader,
    modalSubHeader,
    modalContent,
    resetModal,
  } = props;

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(open);
  }, [open, props]);

  function handleModalClose() {
    setIsOpen(false);
    resetModal();
  }

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <Dialog
      open={isOpen}
      onClose={handleModalClose}
      scroll={scroll}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      fullWidth
      maxWidth={size}
      id="modal-dialog"
    >
      <DialogTitle id="scroll-dialog-title">
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          spacing={0}
          style={{ height: '0px' }}
        >
          <Grid item>
            <IconButton id="modal-close-button" onClick={handleModalClose} style={{ padding: 0 }}>
              <CloseIcon id="modal-close-icon" fontSize="small" />
            </IconButton>
          </Grid>
        </Grid>
        {modalHeader}
      </DialogTitle>
      <DialogContent dividers={scroll === 'paper'}>
        <Typography variant="subtitle1" id="modal-subheader">
          {modalSubHeader}
        </Typography>
        {modalContent}
      </DialogContent>
    </Dialog>
  );
}

ModalComp.defaultProps = {
  open: false,
  size: 'md',
  modalHeader: '',
  modalSubHeader: '',
  modalContent: '',
  resetModal: () => {},
};

ModalComp.propTypes = {
  open: PropTypes.bool,
  size: PropTypes.string,
  modalHeader: PropTypes.node,
  modalSubHeader: PropTypes.string,
  modalContent: PropTypes.node,
  resetModal: PropTypes.func,
};
